<template>
  <div>
    <page-head :title="title"></page-head>
    <div class="content">
      <div class="search">
        <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="不动产业务类型">
                <div class="detail">{{payInfo.orderTypeName}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="不动产业务单号">
                <div class="detail">{{payInfo.orderNO}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="不动产单元号">
                <div class="detail">{{payInfo.estateUnitNO}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="银行名称">
                <div class="detail">{{payInfo.bankName}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="银行经理/权利人">
                <div class="detail">{{payInfo.userName}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="义务人">
                <div class="detail">{{payInfo.obligor}}</div>
              </FormItem>
            </i-col>
            <!-- <i-col span="8">
              <FormItem label="登记费缴纳订单号">
                <div class="detail">{{payInfo.payOrderNo}}</div>
              </FormItem>
            </i-col> -->
             <i-col span="8">
              <FormItem label="支付时间">
                <div class="detail">{{payInfo.updateTime && payInfo.updateTime.substr(0,19)}}</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="税务金额">
                <div class="detail">{{payInfo.payAmount && $util.accDiv(payInfo.payAmount,100)}} 元</div>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="是否开票">
               <div class="detail">{{payInfo.state!=null?invoiceList[+payInfo.state].type:''}}</div>
              </FormItem>
            </i-col>
          </row>
        </Form>
      </div>
      <div class="table-data">
        <div class="verifyRecord">房屋信息</div>
         <Form>
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="产权证号">
                <div class="detail">{{estateInfo &&estateInfo.estateNO}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="房屋所有权人">
                <div class="detail">{{estateInfo && estateInfo.estateOwner}}</div>
              </FormItem>
            </i-col>
              <i-col span="8">
              <FormItem label="共有情况">
                <div class="detail">{{estateInfo && estateInfo.possession}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="房屋坐落">
                <div class="detail">{{estateInfo && estateInfo.address}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="建筑年代">
                <div class="detail">{{estateInfo && estateInfo.buildTime}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="房屋性质">
                <div class="detail">{{estateInfo && estateInfo.houseProperty}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="规划用途">
                <div class="detail">{{estateInfo && estateInfo.planningUse}}</div>
              </FormItem>
            </i-col>
             <i-col span="8">
              <FormItem label="总层数">
                <div class="detail">{{estateInfo && estateInfo.totalFloor}}</div>
              </FormItem>
            </i-col>
              <i-col span="8">
              <FormItem label="规划面积">
                <div class="detail">{{estateInfo && estateInfo.planningArea?estateInfo.planningArea + ' 平方米': ''}}</div>
              </FormItem>
            </i-col>
               <i-col span="8">
              <FormItem label="限制状态">
                <div class="detail">{{estateInfo && estateInfo.limitState}}</div>
              </FormItem>
            </i-col>
          </row>
         </Form>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { taxInfoDetail } = api;
export default {
  name: "regfeeDetail",
  components: {
    pageHead
  },
  data() {
    return {
      title: "登记费用详情",
      payInfo: {},
      estateInfo: {},
       invoiceList: [
         {
           index: 0,
           type: "已冲红",
         },
         {
           index: 1,
           type: "已开票",
         },
         {
           index: 2,
           type: "未开票",
         },
       ],
      typeList: [
        {
          index: 0,
          type: "全部"
        },
        {
          index: 1,
          type: "预告登记"
        },
        {
          index: 2,
          type: "预告登记注销"
        },
        {
          index: 3,
          type: "预抵押登记"
        },
        {
          index: 4,
          type: "预抵押登记注销"
        },
        {
          index: 5,
          type: "现房抵押"
        },
        {
          index: 6,
          type: "现房抵押登记注销"
        },
        {
          index: 7,
          type: "二手房登记"
        },
        {
          index: 8,
          type: "二手房登记"
        },
        {
          index: 9,
          type: "新房办证"
        }
      ],
    };
  },
  methods: {
    async getDetail() {
      try {
       let { orderNO, estateUnitNO, orderType } = this.$route.query;
         let res = await this.$post(taxInfoDetail,{
            orderNO,
            estateUnitNO,
            orderType
        });
        if (res.isSucceed && res.rows) {
          this.payInfo = res.rows[0].payInfo;
          this.estateInfo = res.rows[0].estateInfo;
          console.log(this.estateInfo)
        }
      } finally {
      }
    },
  },
  created() {
    this.getDetail();
  }
};
</script>

<style  scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.detail {
  color: #666;
  padding-top: 1px;
}
.headPicUrl {
  display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
}
.success {
  color: #ff7b44;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 530px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .verifyRecord {
    padding-left: 10px;
    margin-bottom: 20px;
    border-left: 3px solid #ff794e;
    height: 16px;
    line-height: 16px;
  }
}
</style>